import {Button, Image} from "../../../../../../../components";
import documentIcon from "../../../../../../../assets/images/svg/document.svg";
import FileSize from "../../../../../../../components/common/utils/FileSize/FileSize";
import {formatDate} from "../../../../../../../formatters";
import React, {useState} from "react";
import styles from '../DocumentsToProjectsItem.module.scss';
import dots from "../../../../../../../assets/images/svg/dots-green.svg";
import {Agreement} from "../../../../../../../api-client/models/documents/Agreement";
import {translateAgreementType} from "../../../../../../../api-client/enums/AgreementType";
import {createAgreementProvider} from "../../../../../../../di";
import apiClientConfig from "../../../../../../../configs/app";

interface Props {
    document: Agreement
}

export const AgencyOrder = ({document}: Props) => {
  const [activeDownload, setActiveDownload] = useState(false);

  const downloadSigned = async () => {
    try {
      const provider = await createAgreementProvider();
      if (document.investmentUuid) {
        const result = await provider.createSignedAgreement(document.investmentUuid, document.uuid);
        window.open(apiClientConfig.apiBaseUrl + result.url, '_blank');
      }
    } catch (error) {
      if (error instanceof Error) {
        console.error(error);
      }
    }
  };


  return (
    <li className={styles.documentsToProjectBody__list}>
      <div className={styles.documentsToProjectBody__item}>
        <Image className={styles.documentsToProjectBody__icon}
          src={documentIcon}/>
        <a href={document.file.url}
          target="_blank" rel="noreferrer"
          className={styles.documentsToProjectBody__title}>{translateAgreementType(document.type)}</a>
        <a href={document.file.url}
          target="_blank" rel="noreferrer" className={styles.documentsToProjectBody__size}>pdf, <FileSize
            file={document.file}/></a>
        <a href={document.file.url}
          target="_blank" rel="noreferrer" className={styles.documentsToProjectBody__watch}>Нажмите, чтобы
          посмотреть
        </a>
        <a href={document.file.url}
          target="_blank" rel="noreferrer"
          className={styles.documentsToProjectBody__date}>{formatDate(document.createdAt)}</a>
        <a href={document.file.url}
          target="_blank" rel="noreferrer" className={styles.documentsToProjectBody__dateText}>дата
          подписания
        </a>

        {document.digitalSign &&
        <div className={styles.documentsToProjectBody__makeReport}>
          <Button className={styles.documentsToProjectBody__buttonSave}
            onClick={() => setActiveDownload((prevState) => !prevState)}>
            <div/>
            скачать <Image className={styles.documentsToProjectItemTitle__arrowButton__image__download}
              src={dots}/>
          </Button>
          {activeDownload && <div className={styles.documentsToProjectBody__download}>
            <Button
              className={styles.documentsToProjectBody__buttonDownload}
              onClick={downloadSigned}>
              <div/>
              Скачать PDF
            </Button>
          </div>}
        </div>}
      </div>
    </li>
  );
};